import { useState, useEffect } from "react";

export function useAnimatedText(text: string, delay: number = 0) {
  const [displayedChars, setDisplayedChars] = useState<string[]>([]);

  useEffect(() => {
    const chars = text.split("");
    const timeout = setTimeout(() => {
      let i = 0;
      const interval = setInterval(() => {
        setDisplayedChars((prev) => [...prev, chars[i]]);
        i++;
        if (i >= chars.length) clearInterval(interval);
      }, 15); // Adjust this number for speed (15ms is very fast)
    }, delay * 1000);

    return () => {
      clearTimeout(timeout);
    };
  }, [text, delay]);

  return displayedChars;
}
